import axios from './request';
import { prop, pipe, map, defaultTo, tap } from 'ramda';

/**
 * @typedef City
 * @property {string} CODE
 * @property {string} CITY_NAME
 * @property {string} id
 * @property {string} text
 * @property {string | null} region
 */

class StringableCity {
	/**
	 * @this {City}
	 * @returns {string}
	 */
	toString() {
		const { region, text: city } = this;

		return region ? `${city}, ${region}` : city;
	}
}

/**
 *
 * @param {City} item
 */
function createCity(item) {
	/** @type {City & StringableCity} */
	const city = Object.setPrototypeOf(item, StringableCity.prototype);

	return city;
}

/**
 *
 * @param {string} query
 * @param {import('axios').AxiosRequestConfig?} config
 * @returns {Promise<(StringableCity & City)[]>}
 */
export default function getCities(query, config) {
	return axios.get('/api/Location/getCities/', {
		...config,
		responseType: 'json',
		params: {
			term: query,
			q: query,
			'_type': 'query',
		},
	})
		.then(({ data }) => data)
		.then(pipe(
			prop('results'),
			defaultTo([]),
			map(createCity)
		))
}
